// Config/navegacion.js
export const BOTONES_NAVEGACION = [
  {
    paso: 'Despacho',
    label: 'Despacho',
    icono: 'fa-solid fa-door-open'
  },
  {
    paso: 'Vehiculo',
    label: 'Vehículo',
    icono: 'fa-solid fa-car'
  },
  {
    paso: 'Ruta',
    label: 'Ruta',
    icono: 'fa-solid fa-route'
  },
  {
    paso: 'Autorizaciones',
    label: 'Autorizaciones',
    icono: 'fa-solid fa-thumbs-up'
  },
  {
    paso: 'Conductores',
    label: 'Conductores',
    icono: 'fa-solid fa-id-card'
  },
  {
    paso: 'Novedades',
    label: 'Novedades',
    icono: 'fa-solid fa-thumbtack'
  },
  {
    paso: 'NovedadesVehiculo',
    label: 'Novedades Vehículo',
    icono: 'fa-solid fa-truck'
  },
  {
    paso: 'NovedadesConductor',
    label: 'Novedades Conductor',
    icono: 'fa-solid fa-truck'
  },
  {
    paso: 'LlegadasVehiculo',
    label: 'Llegadas Vehículo',
    icono: 'fa-solid fa-truck'
  },
  {
    paso: 'LlegadasConductor',
    label: 'Llegadas Conductor',
    icono: 'fa-solid fa-truck'
  },
  {
    paso: 'Llegadas',
    label: 'Llegadas',
    icono: 'fa-solid fa-truck'
  }
];